module.exports = __webpack_public_path__ + "static/assets/74605418501bec989fa1c9611c98c367.svg";